export default {
	// AI block start
	'buttonAiMainText': 'AI Analysis',
	'firstLoadOrderInAi': 'Идет загрузка заказа в AI ... Ожидайте результата анализа ...',
	// AI block end

	'amountForAuthor': 'Выплата автору',
	'addNewamountForAuthor': 'Добавить выплату автору',
	'paymentIsFixed': 'Выплата зафиксированна',
	'calculateSalary': 'Рассчитать зарплату',
	'managerType': 'Класс',
	'orderOnlyPremium': 'Премиум заказы',
	'saveCardStages': "Сохранить этап",
	'plainChannelWhatsapp': 'Номер канала',
	'nameChannelWhatsapp': 'Название канала',
	'stateChannelWhatsapp': 'Статус',
	'listStateChannelWhatsapp': {
		'active': 'канал активен',
		'init': 'канал запускается',
		'disabled': 'канал выключен: его убрали из подписки или удалили с сохранением сообщений',
		'phoneUnavailable': 'нет связи с телефоном',
		'qridle': 'необходимо отсканировать QR-код',
		'openelsewhere': 'канал авторизован в другом аккаунте Wazzup',
		'notEnoughMoney': 'канал не оплачен',
		'foreignphone': 'QR канала отсканирован не тем аккаунтом в мессенджере (с другим номером телефона)',
		'unauthorized': 'не авторизован',
		'waitForPassword': 'нужно ввести пароль для двухфакторной аутентификации',
		'blocked': 'Facebook заблокировал канал',
		'onModeration': 'канал WABA находится на модерации',
		'rejected': 'канал WABA отклонен',
	},
	'channels': 'Каналы',
	'isExpired': 'просрочено',
	'noManager': 'Менеджер не назначен',
	'selectResponsible': 'Укажите ответственного менеджера',
	'areaResponsibility': 'Зона ответственности',
	'responsible': 'Ответственный',
	'generalPriceListForAuthors': 'Общие настройки цен для сайтов',
	'specialPriceForAuthors': 'Специальная цена для авторов',
	'whatsappNameChannel': 'Канал',
	'whatsappFirstReadMess': 'Прочтено',
	'whatsappFirstSentMess': 'Отправлено',
	'yesterdayDay': 'вчера',
	'nameWhatsappChannel': 'Канал',
	'messageWhatsappLastText': 'Последнее сообщение',
	'messageText': 'Сообщение',
	"txtInChatReplyTo": 'В ответ на',
	"replyTo": 'Ответить',
	"thereAreUnfilledFields": "Необходимо правильно заполнить все поля перед сохранением!",
	"utmSource": "Источник лида",
	"utmMedium": "Тип рекламы",
	"utmCampaign": "№ кампании",
	"utmTerm": "Ключевая фраза",
	"chooseAuthor": "Выберите автора",
	"noManagerWhatsAppChat": "без менеджера",
	"emaiErrorlList": {
		"EMAIL_ERROR_MAILBOX_NOT_FOUND": "Адрес получателя отклонен: почтовый ящик не найден",
		"EMAIL_ERROR_UNIDENTIFIED_ERROR": "Возникла неопознанная ошибка при отправки почты, обратитесь в техническую поддержку",
		"EMAIL_ERROR_MESSAGE_EXPIRED": "Срок действия сообщения истек: невозможно доставить в течение 840 минут",
		"EMAIL_ERROR_STOP_LIST_AMAZON_SES": "Email не отправлен, так как адрес в стоп листе на Amazon SES",
		"EMAIL_ERROR_MAILBOX_FULL": "Письмо не доставлено - ящик получателя переполнен",
		"EMAIL_ERROR_INVALID_DOMAIN": "Письмо не доставлено - домен получателя не существует",
		"EMAIL_ERROR_CLIENT_ABUSE_SPAM": "Клиент заблокировал email из CRM и пожаловался на спам от CRM",
	},
	'emailSpamList': 'spam Email',
	'presentationPdfNameHref': 'Текстовое название ссылки для презентации',
	'italian': "Italiano",
	'french': "Français",
	// Новые с 27.10.23
	'infoAboutAuthor': 'Информация об авторе',
	'emailAliasAuthor': "Email псевдоним автора",
	'emailAuthor': "Email автора",
	'fioAuthor': "Имя автора",
	'fioAliasAuthor': "Псевдоним автора",
	'activeOrderAuthor': "Активные заказы автора",
	'urlProfileAuthor': "Профиль автора",
	'whatsappListChats': "Whatsapp",
	'whatsappDashboard': 'Whatsapp',
	'nameListChatWhatsapp': "Список чатов Whatsapp",
	'whatsappChat': "Whatsapp чат",
	'whatsappChatMissingCall': "Пропущенный звонок",

	'editWithoutNotice': 'Редактировать без уведомлений',
	'editOffWithoutNotice': 'Выключить режим редактирования',
	'titleSystemMessage': 'Системное сообщение',
	'partner': 'Партнер',
	'lastMassages': 'Переписка',
	'last50MessagesManager': 'Последние 50 отправленных вами сообщений',
	'noLast50MessagesManager': 'Пока сообщений нет',
	'emailFrontSite': 'Почта указанная на сайте',
	'isPartnerWebsite': 'Сайт партнера',
	'partners': 'Партнеры',
	'countWebsites': 'Кол-во сайтов',
	'siteChatResponseTemplates': 'Чат-шаблоны',
	'siteChatResponseTemplatesName': 'Название',
	'siteChatResponseTemplatesTemplate': 'Текст ответа',
	'chatTemplates': 'Чат-шаблоны',
	'name_ru': 'Название (рус)',
	'name_de': 'Название (нем)',
	'emailPartner': 'Логин партнера',
	'countWebsitePartner': 'Количество сайтов',
	'passPartner1': 'Новый пароль для партнера',
	'passPartner2': 'Повторите новый пароль',
	'partnerCreateAccount': 'Время создания аккаунта партнера',
	'partnerFirstName': 'Имя партнера',
	'partnerLastName': 'Фамилия партнера',
	'partnerWasCreatedSuccessfully': "Аккаунт партнера был успешно создан",
	'stageNumberInOrder': 'Поставка',
	'fileNumbering': 'файл №',
	'paymentStage': 'Оплата',
	'checkYesPaymentStage': 'Поступила',
	'checkNoPaymentStage': 'Не поступила',
	'files': 'Файлы',
	'filesAreNotUploaded': 'Файлы не загружены',
	'AuthorTasks': 'Задачи',
	'currentMilestonesPagesCount': 'Сначала',
	'closeOrderWithoutNotice': 'Экспресс закрытие',
	'confirmActionWithoutNotice': 'Подтверждаю закрытие',
	'youWantСloseOrderWithoutNotice': "Вы собираетесь отметить текущий заказ как успешно завершенный и закрыть его без уведомлений клиенту",
	'youSuccessСloseOrderWithoutNotice': "Заказ успешно закрыт без уведомлений, как выполненный",
	'invoiceFooterTitle': "Футер в платежках (PDF)",
	'noTask': "Задач пока нет",
	'MyAuthorsTasks': "Дедлайны",
	'taskAboutOrder': "Задачи",
	'noOrderTask': "Актуальных задач по заказу нет",
	'logAboutOrder': "История",
	'noOrderComment': "Истории по заказу нет",
	'typeEvent': "Событие",
	'systemTypeEvent': "Системное событие",
	'needAuthorPutPage': "Автору нужно сдать в срок этап. Страниц",
	'logInMenu': "Логи",
	"orderLog": {
		"NewEmailChangeClientNotAnswerToStatusProcessing": "статус \"Без ответа\" -> \"В обработке\", получено письмо от клиента",
		"createNewOrderFromEmail": "Заказ создан на основе email",
		"createNewOrderFromSiteForm": "Заказ создан через форму на сайте",
		"createNewOrderFromCRM": "Заказ создан в CRM",
		"changeStatusOrder": "Изменение статуса заказа",
		"addNewMilestone": "Добавление нового этапа к заказу",
		"deleteMilestone": "Удаление этапа из заказа",
		"orderStandartCompletedWithPayout": "Стандартное успешное закрытие завершенного заказа с выплатами автору",
		"deleteAuthorFromOrder": "Удаление из заказа автора",
		"appointManagerInOrder": "Назначение в заказ нового менеджера",
		"managerAcceptedOrder": "Менеджер-продажник подтвердил получение заказа",
		"managerSecondAcceptedOrder": "Менеджер-саппорт подтвердил получение заказа",
		"setMarkAsReadChactClient": "Чат с клиентом отмечен прочитанным",
		"updatingOrderData":  "Обновление данных о заказе",
		"updatingStageData": "Обновление данных об этапе",
		"confirmPaymentMilestone": "Подтверждено поступление денег на счет за оплату этапа",
		"changeOrderStatusToInProgressAndAddAuthor": "-> \"В процессе\", назначен новый автор",
		"setFailedOrder": "Заказ отмечен как проваленный и закрыт",
		"setConfirmedOrder": "Заказ отмечен как успешно завершенный и закрыт",
		"setNewPriceJmOrderMilestone": "Назначена новая цена для Junior & Middle авторов для этапа. Новая ставка: ",
		"setNewPriceSOrderMilestone": "Назначена новая цена для Senior авторов для этапа. Новая ставка: ",
		"moveOrderToTrash": "Заказ перемещен в корзину и закрыт",
		"moveEmailToSpamList": "EMAIL клиента внесен в спам-лист CRM. Письма от клиента будут игнорироваться.",
		"addWorkTypeToOrder": "В заказ добавлен новый тип работы. Страниц: ",
		"changeOrderStatusToClientNotAnswer": "-> \"Без ответа\"",
		"setCloseOrderWithoutNotice": "Заказ отмечен как успешно завершенный и закрыт без уведомлений для клиента",
		"sendOrderForApproval": "Заказ отправлен клиенту на утверждение",
		"changeOrderStatusToWaitingPayment": "-> \"Ожидает оплату\"",
		"changeOrderStatusToProcessing": "-> \"В обработке\"",
		"changeOrderStatusToWaitingAuthor": "-> \"В поиске исполнителя\"",
		"changeOrderStatusToInProgress": "-> \"В процессе\"",
		"changeOrderStatusToWaitingApprove": "-> \"Подтверждается\"",
		"changeOrderStatusToPatchMode": "-> \"В режим правок\"",
		"autoDistributionOfManagersSuccess": "Автоматическое назначение в заказ нового менеджера",
		"autoDistributionOfManagersError": "Не удалось автоматически назначить нового менеджера",
		'autoDistributionOfManagersToWhatsappSuccess': 'Автоматическое назначение в чат WhatsApp нового менеджера',
		'autoDistributionOfManagersToWhatsAppError': 'Не удалось автоматически назначить в чат WhatsApp нового менеджера',
		"noManagerInDayDutySchedule": "В текущей смене нет менеджеров",
		"dubleOrderIn10Minutes": "Дубль заявки за последние 10 минут",
		"noIfInDayDutySchedule": "Нет условий для выбора менеджера",
		"noFreeOtherManagerInDayDutySchedule": "В дежурной смене нет менеджера, который еще не работал с этим клиентом",
		"switchOnlineManager": "Менеджер вернулся в онлайн",
		"switchOfflineManager": "Менеджер ушел в оффлайн",
		"switchAllowedFollowUpOrder": "Follow-up сообщения включены для заказа клиента",
		"switchNotAllowedFollowUpOrder": "Отключение follow-up сообщений для заказа клиента",
		"autoCompletionOrderAfter5Days": "Автоматическое завершение заказа спустя 5 дней молчания клиента",
		'changeNewGeneralManager': "Назначен новый главный менеджер: ",
		'changeOrderStatusToClientNotAnswer': "-> \"Без ответа\" ",
		'managerEmailchangeOrderStatusToClientNotAnswer': "после письма менеджера ",
		'managerAcceptOrderchangeOrderStatusToClientNotAnswer': "после принятия заказа менеджером ",
		'managerCreateOrderchangeOrderStatusToClientNotAnswer': "после создания заказа менеджером ",
		'authorLeaveOrder': "Заказ покинул автор ",
		'authorAcceptOrder': "Заказ принял в работу автор ",
	},
	'dateTimeEvent': "Время события",
	'numberOrder': "№ заказа",
	"noNextManager": "---",
	"managerDutySchedule": "График дежурств",
	"managerDutyScheduleH1": "График дежурств менеджеров",
	"managerDutyScheduleNameFirstLine": "1-я линия",
	"managerDutyScheduleNameSecondLine": "2-я линия",
	"goBack": "Вернуться обратно",
	"selectMultiManagersTitle": "Выберите менеджеров ...",
	"doYouWantToDeleteManagerFromDay": "Вы собираетесь удалить менеджера из графика на этот день",
	"tariffSchedule": "Тарифная сетка",
	"iAmOnline": "Я онлайн",
	"iAmOffline": "В оффлайне",
	"changeStatusManagerTitle": "Изменение статуса",
	"doYouWantStatusOfflineManager": "Вы уходите в оффлайн и приостанавливаете приём заказов",
	"doYouWantStatusOnlineManager": "Вы возвращаетесь в онлайн и готовы принимать заказов",
	"switchOfflineManagerNotification": "Вы ушли в оффлайн",
	"switchOnlineManagerNotification": "Вы снова онлайн",
	"onlineStatusManager": "Статус",
	"online": "Онлайн",
	"offline": "Оффлайн",
	"statusFollowUp": "Статус follow-up рассылок",
	"allowedFollowUp": "Follow-up разрешены",
	"notAllowedFollowUp": "Follow-up отключены",
	"doYouWantStatusAllowedFollowUpOrder": "Вы разрешаете посылать клиенту follow-up сообщения",
	"doYouWantStatusNotAllowedFollowUpOrder": "Вы отключаете рассылку клиенту follow-up сообщений",
	"switchNotAllowedFollowUpOrderNotification": "Вы отключили рассылку follow-up сообщения для клиента",
	"switchAllowedFollowUpOrderNotification": "Вы разрешили посылать follow-up сообщения для клиента",
	"authorCostPerPageH1": "Стоимость одной страницы для автора, в евро",
	"allowAuthorPaymentReward": "Вы подтверждаете завершение этапа и выплату гонорара автору?",
	'balance': "Баланс",
	'topManager': "Главный",
	'changeGeneralManagerTitle': "Смена главного менеджера",
	'doYouWantChangeGeneralManager': "Назначить новым главным менеджером ",
	'rating': "Рейтинг",
	'newbie': "Новичок",
	'paymentsHistoryOrders': "Начисления",
	'titleDialogChangeOrderStatus': "Выберите новый статус заказа ...",
	'emailAliasManager': "Email псевдоним",
	'sendFromAuthor': "от автора",
	'uploadCompletedStage': "Загрузите выполненный этап.",
	'modify': "Доработать",
	'forRevision': "На доработку",
	'returnToAuthorForRevision': "Вернуть автору на доработку ...",
	'addCommentForAuthor': "Сообщите здесь автору, что нужно изменить:",
	'changeStatusOrderToPatchModeStage': 'Вы успешно отправили этап на доработку автору',
	'waitForConfirmationJobAcceptance': "Ожидайте подтверждения принятия работы.",
	'stagePatchModeNumber': "Доработка",
	'editingModeEnabled': "Включен режим правок",
	'acceptJob': "Принять работу",
	// Новые с 27.10.23

	'addTicket': "Добавить заказ",
	'addTask': "Добавить задачу",
	'addOrderComment': "Добавить комментарий",
	'noOrderComment': "Комментариев по заказу нет",
	'unknowUserRole': "Неизвестный автор",
	'unknowUserName': "Неизвестно",
	'addOrderCommentSuccess': "Комментарий успешно добавлен к заказу!",
	'from': "От",
	'to': 'До',
	'reset': "Сбросить",
	'searchByNameAndClient': "Email клиента или название заказа",
	'save': "Сохранить",
	'cancel': "Отмена",
	'chooseDate': "Выберите дату",
	'description': "Описание",
	'taskView': "Описание задачи",
	'date': "Дата",
	'ticket': "Заказ",
	'setByAdmin': "Важно!",
	'delete': "Удалить",
	'done': "Выполнено",
	'notDone': "Не выполнено",
	'completedSuccessfully': "Успешно выполнено",
	'addedSuccessfully': "Успешно добавлено",
	'setPriceSuccessfully': "Цена успешно изменена",
	'changedSuccessfully': "Успешно изменено",
	'deletedSuccessfully': "Успешно удалено",
	'name': "Название",
	'subject': "Предмет",
	'type': "Тип",
	'pagesCount': "Страниц",
	'milestonesCount': "Этапов",
	'priceEuro': "Цена, €",
	'dueDate': "Дедлайн",
	'dueTimeAuthor': "Дедлайн для автора",
	'manager': "Менеджер",
	'comment': "Комментарий",
	'client': "Клиент",
	'level': "Уровень",
	'author': "Автор",
	'task': "Задачи",
	'new': "Новые",
	'transmitted': "Передаются",
	'forRemoval': "На удаление",
	'clientNotAnswer': "Без ответа",
	'processing': "В обработке",
	'waitingPayment': "Ожидает оплаты",
	'waitingAuthor': "В поиске исполнителя",
	'inProgress': "В процессе",
	'patchMode': "Правки",
	'waitingApprove': "Подтверждается",
	'completed': "Выполнено",
	'failedWithPayout': "Провалено (гонорар выпл.)",
	'failed': "Провалено",
	'createOrder': "Создание заказа",
	'newtonsLaw ': "Закон Ньютона",
	'clientsPhone': "Телефон клиента",
	'clientsEmail': "E-mail клиента",
	'clientsEmailSecondary': "E-mail клиента (доп.)",
	'site': "Сайт",
	'email_host': "Адрес почтового сервера входящей почты",
	'emailIncomingUserName': 'Логин почтового сервера входящей почты',
	'passIncomingEmail': 'Пароль почтового сервера входящей почты',
	'emailPort': "Порт почтового сервера входящей почты",
	'emailSecure': "Протокол почтового сервера входящей почты",
	'emailOutgoingHost': "Адрес почтового сервера исходящей почты",
	'emailOutgoingUserName': 'Логин почтового сервера исходящей почты',
	'emailOutgoingUserPassword': 'Пароль почтового сервера исходящей почты',
	'emailOutgoingPort': "Порт почтового сервера исходящей почты",
	'emailOutgoingSecure': "Протокол почтового сервера исходящей почты",
	'subjectArea': "Предмет",
	'workType': "Тип работы",
	'qualityLevel': "Уровень качества",
	'pagesAmount': "Количество страниц",
	'workLanguage': "Язык выполнения",
	'language': "Язык",
	'loadFile': "Загрузить файл",
	'create': "Создать",
	'orderWasCreatedSuccessfully': "Заказ успешно создан",
	'order': "Заказ",
	'currentOrderStatus': "Текущий статус заказа",
	'price': "Цена",
	'refuseWork': "Отказаться от заказа",
	'writeMessage': "Написать сообщение",
	'chatWithAurhor': "Чат с Автором",
	'chatWithManager': "Чат с Менеджером",
	'invitesWasSent': "Приглашения отправлены",
	'youMarkedOrderAs': "Вы отметили заказ как",
	'confirmAction': "Подтвердите действие",
	'checkFullPaymentStage': "От клиента пришла полная сумма?",
	'agree': "Начать заказ",
	'youWantToMarkOrderAs': "Вы собираетесь отметить заказ как",
	'totalWorks': "Всего заказов",
	'currentWorks': "Текущих заказов",
	'favorites': "Избранные",
	'invite': "Пригласить",
	'performersRequests': "Заявки исполнителей",
	'select': "Выбрать",
	'yourRequestsWasSentSuccessfully': "Ваши приглашения были успешно отпралены",
	'youHaveAssignedAuthorToThisProject': "Вы назначили автора на этот заказ",
	'thanksWeReceivedYourRequest': "Спасибо, мы получили вашу заявку",
	'managerWillConfirmItSoon': "Менеджер скоро ее подтвердит",
	'pleaseWait': "Пожалуйста, подождите",
	'paymentDetails': "Детали оплаты",
	'stage': "Этап",
	'priceForClient': "Цена для клиента",
	'priceForJuniorAndMiddle': "Цена для Junior & Middle",
	'newPriceForJuniorAndMiddle': "Новая цена для Junior & Middle",
	'priceForSenior': "Цена для Senior",
	'newPriceForSenior': "Новая цена для Senior",
	'pagesAmountShort': "Кол-во страниц",
	'loadPhoto': "Загрузить фото",
	'downloadChecks': "Загрузить чеки",
	'confirmPayment': "Подтвердить оплату",
	'recommendedPaymentSum': "Рекомендуемая сумма к оплате",
	'totalPaymentSum': "Всего сумма к оплате",
	'lowerThanRecommendedSum': "Сумма меньше рекомендуемой",
	'addStage': "Добавить этап",
	'sendForApproval': "Отправить на утверждение",
	'edit': "Редактировать",
	'approve': "Утвердить",
	'firstlyAddWorkTypeToOrder': "Выберите тип работы",
	'youdownloadChecksSuccessfully': "Вы успешно загрузили чеки",
	'youConfirmedPaymentSuccessfully': "Вы успешно подтвердили оплату",
	'dataWasSentToClientForApproval': "Файлы отправлены клиенту",
	'dataWasSentForApproval': "Документ отправлен на утверждение",
	'youMarkedStageAs': "Вы отметили этап как",
	'stageWasMovedToStatus': "Изменение статуса заказа:",
	'payRewardToAuthor': "Выплатить гонорар автора",
	'authorsReward': "Сумма гонорара",
	'pay': "Выплатить",
	'doCancel': "Отменить",
	'indicateFailureReason': "Укажите причину провала",
	'informationAboutOrder': "Информация",
	'editInformationAboutOrder': "Редактировать",
	'commentAboutOrder': "Комментарии",
	'workName': "Тема",
	'clientsComment': "Комментарий клиента",
	'recommendedSumShort': "Реком. сумма",
	'add': "Добавить",
	'attachedFiles': "Прикрепленные файлы | Прикрепленный файл | Прикрепленные файлы | Прикрепленные файлы",
	'paymentMethod': "Способ оплаты",
	'filesFromAuthor': "Файлы от автора",
	'send': "Отправить",
	'sendAutomatically': "Отправлять автоматически",
	'filesWasSentToClient': "Файлы были отправлены клиенту",
	'refuse': "Отказаться",
	'youWantToCompleteOrder': "Вы собираетесь завершить заказ",
	'thisActionIsIrreversible': "Данное действие необратимо",
	'completeOrder': "Завершить заказ",
	'orderIsCompletedSuccessfully': "Заказ успешно завершен",
	'writeToManager': "Написать менеджеру",
	'discuss': "Обсуждается",
	'creationDate': "Дата создания",
	'calculatedSum': "Расчетная цена",
	'includingVAT': "включая НДС",
	'assign': "Назначить",
	'chooseManager': "Выберите менеджера",
	'passwordRecovery': "Восстановление пароля",
	'enterYourEmailAndWeWillSendYouNewPassword': "Введите свой email и мы отправим вам новый пароль",
	'recoverPassword': "Восстановить пароль",
	'toLoginPage': "На страницу входа",
	'newPasswordIsGeneratedAndSentToMail': "Новый пароль отправлен на почту",
	'registration': "Регистрация",
	'fillFormBelowToCreateNewAccount': "Заполните форму ниже, чтобы создать новую учетную запись",
	'youAreAlreadyLoggedIn': "Вы уже вошли в систему!",
	'entrance': "Вход",
	'welcomeBack': "С возвращением",
	'pleaseLoginToYourAccount': "Пожалуйста, войдите в свой аккаунт",
	'password': "Пароль",
	'repeatPassword': "Повторите пароль",
	'newPassword': "Новый пароль",
	'yes': "Да",
	'no': "Нет",
	'confirmDeletion': "Подтвердите удаление",
	'doYouWantToDelete': "Вы собираетесь удалить",
	'registrationLinkCreation': "Создание ссылки для регистрации",
	'linkToRegistrationForm': "Ссылка на форму регистрации",
	'generate': "Сгенерировать",
	'close': "Закрыть",
	'nickname': "Никнейм",
	'emailForPayment': "SEPA IBAN / Transferwise-Email",
	'phone': "Телефон",
	'sex': "Пол",
	'country': "Страна",
	'birthDate': "Дата рождения",
	'surname': "Фамилия",
	'profile': "Профиль",
	'subjects': "Предметы",
	'aboutYourself': "О себе",
	'dataIsSaved': "Данные сохранены",
	'totalOrdersCount': "Общее количество заказов",
	'success': "Успешность",
	'personName': "Имя",
	'otherCustomerProfiles': "Другие профили",
	'changeWorkType': "Изменить тип работы",
	'shortRussian': "рус",
	'shortGerman': "нем",
	'totalTicketsAmount': "Общее количество заказов",
	'activatedTickets': "Активных заказов",
	'income': "Доход",
	'totalIncome': "Общий доход",
	'clientEditing': "Редактирование клиента",
	'additionalEmail': "Дополнительный Email",
	'activatedOrder': "Активных заказов",
	'changingManagerRequest': "Запрос на смену менджера",
	'newManager': "Новый менеджер",
	'confirm': "Подтвердить",
	'decline': "Отклонить",
	'firstlySelectManager': "Нужно сначала указать менеджера",
	'changingManagerRequestIsSent': "Отправлен запрос на смену менеджера",
	'requestWasDeclined': "Запрос был отменен",
	'searchByName': "Поиск по имени",
	'actions': "Действия",
	'totalOrders': "Всего заказов",
	'paidOrder': "Оплаченные",
	'hangingOrders': 'Повисшие',
	'sitesPreferences': "Настройки для сайтов",
	'managerEditing': "Редактирование менеджера",
	'managerCreating': "Создание менеджера",
	'sitesSettings': "Настройки сайта",
	'basicPrices': "Базовые цены",
	'workTypesVisibility': "Видимость типов работ",
	'invoicesData': "Данные для инвойсов",
	'siteAutoEmailAnswer': "Автоматические ответы",
	'siteAutoEmailName': "Событие",
	'siteAutoEmailDialogTitile': "Изменить автоматический ответ сайта",
	'siteChatResponseDialogTitile': "Изменить чат-шаблон сайта",
	'siteAutoEmailTemplate': "Текст письма",
	'siteAutoEmailLetterSubject': "Тема письма (до 255 символов)",
	'siteAutoEmailTemplateSuccess': "Текст ответа для сайта обновлен!",
	'siteAutoEmailParameter': "Возможные параметры для подстановки",
	'changesIsSavedSuccessfully': "Изменения успешно сохранены",
	'siteWasCreatedSuccessfully': "Сайт был успешно создан",
	'managersFee': "Гонорар менеджера-продажника, % от заказа",
	'managersFeeSecond': "Гонорар менеджера-саппорта, % от заказа",
	'managersGeneralFee': "Гонорар главного менеджера, % от заказа",
	'deleteLogo': "Удалить лого",
	'firmInfo': "Информация о фирме",
	'termsAndConditions': "Условия и положения",
	'part': "часть",
	'addPresentationPdf': "Добавление презентации для сайта",
	'deletePresentationPdf': "Удалить презентацию",
	'changePresentationPdf': "Заменить презентацию",
	'changeLogo': "Изменить лого",
	'mainColor': "Основной цвет",
	'additionalColor': "Дополнительный цвет",
	'highlightingText': 'Цвет текста названия сайта в CRM',
	'highlightingBackground': 'Цвет фона текста названия сайта в CRM',
	'showForJunior': "Показать для Junior",
	'showForMiddle': "Показать для Middle",
	'showForSenior': "Показать для Senior",
	'general': "Общая",
	'bySites': "По сайтам",
	'openDiscuss': "Открыть обращение",
	'opened': "Открытые",
	'number': "Номер",
	'discussTheme': "Тема обращения",
	'status': "Статус",
	'lastAnswer': "Последний ответ",
	'answerReceived': "Ответ получен",
	'waitingToAnswer': "Ожидает ответа",
	'closed': "Закрытые",
	'isClosed': "Закрыто",
	'openNewDiscuss': "Открыть новое обращение",
	'discussText': "Текст обращения",
	'doYouWantToCloseDiscuss': "Вы собираетесь закрыть обращение",
	'closeDiscuss': "Закрыть обращение",
	'aDiscuss': "Обращение",
	'discussStatus': "Статус обращения",
	'write': "Написать",
	'techSupport': "Тех.поддержка",
	'pendingConsideration': "Ожидает рассмотрения",
	'paidOut': "Выплачено",
	'rejected': "Отклонено",
	'payRequest': "Вывод средств",
	'writeHowMuchYouWantToWithdraw': "Укажите какую сумму Вы хотите вывести",
	'rejectPayment': "Отклонить платеж",
	'paymentRejectingReason': "Причина отклонения платежа",
	'currentBalance': "Текущий баланс",
	'withdraw': "Вывести",
	'rejectSuccessfully': "Успешно отклонено",
	'idTransaction': "ID транзакции",
	'sum': "Сумма",
	'paymentSystem': "Платежная система",
	'paymentRequests': "Запросы на выплату",
	'paymentsHistory': "История выплат",
	'user': "Пользователь",
	'rejectedPayments': "Отклоненные выплаты",
	'addWorkType': "Добавить тип работы",
	'responseText': "Текст ответа",
	'addAnswer': "Добавить ответ",
	'ago': "назад",
	'month(1)': "месяц",
	'month(2-5)': "месяца",
	'month(6-0': "месяцев",
	'more': "Больше",
	'lessThanMonth': "Меньше месяца",
	'markAllAsRead': "Отметить все как прочитанные",
	'orders': "Заказы",
	'techSupportShort': "Тех. поддержка",
	'exchangePageName': "Биржа",
	'tickets': "Заказы",
	'statistics': "Статистика",
	'finances': "Финансы",
	'tasks': "Задачи",
	'clients': "Клиенты",
	'managers': "Менеджеры",
	'authors': "Авторы",
	'sites': "Сайты",
	'workTypes': "Типы работ",
	'templateAnswers': "Шаблонные ответы",
	'scheduledTasks': "Задачи",
	'all': "Все",
	'notDone(many)': "Актуальные",
	'notRelevant': "Не актуально",
	'changeStatusTaskTitle': "Измененние статуса задачи",
	'doYouWantStatusTaskNotRelevant': "Пометить задачу как не актуальную?",
	'switchStatusTaskNotRelevantNotification': "Вы пометили задачу не актуальной",
	'doYouWantDeleteTask': "Удалить задачу?",
	'deleteTaskNotification': "Вы удалили задачу",
	'doYouWantCompletedTask': "Завершить задачу?",
	'completedTaskNotification': "Вы пометили задачу завершенной",
	'sort': "Сортировка",
	'tasksCalendar': "Календарь задач",
	'languages': "Языки",
	'accessDenied': "Доступ запрещён",
	'addPhoto': "Добавьте фото",
	'male': "Мужчина",
	'female': "Женщина",
	'searchByOrderName': "Поиск по названию",
	'addOrder': "Добавить заказ",
	'doYouWantToRejectOrder': "Вы собиретесь откзаться от заказа",
	'yourPersonalManager': "Ваш личный менеджер",
	'requestAnotherManager': "Запросить другого менеджера",
	'writeReason': "Опишите причину",
	'profileEditing': "Редактирование профиля",
	'changePhoto': "Изменить фото",
	'deletePhoto': "Удалить фото",
	'chatWithYourManager(p1)': "Чат с вашим",
	'chatWithYourManager(p2)': "Менеджером",
	'chatByOrder': "Чат по заказу",
	'chatAuthorByOrder': "Чат с автором по заказу",
	'chatWithManagerByOrder': "Чат с Менеджером по заказу",
	'search': "Поиск",
	'copywriter': "Автор",
	'admin': "Администратор",
	'successNotification': "Успешно",
	'dangerNotification': "Внимание",
	'errorNotification': "Ошибка",
	'fieldFilledIncorrect': "Поле заполнено некорректно",
	"trash": "Корзина",
	"titleDialogMoveTrash": "Переместить заказ в ...",

	// --------------- Чат
	'chatTrekingOpensTimes': "Opens times",
	'chatTrekingLastOpened': "Last opened",

	// --------------- Заказ
	'orderFailedFeeNotPaid': "Заказ провален - клиент отказался (гонорар не выплачен)",
	'orderFailedFeePartiallyFullyPaid': "Заказ провален - клиент отказался (гонорар частично/полностью выплачен)",
	'clientNotContacting': "Заказ провален - клиент не отвечает",
	'spam': "Спам",
	'duplicate': "Дубликат",

	// --------------- V2
	'newMessagesCountDisplay': "Новых",
	'logout': "Выйти",
	'russian': "Русский",
	'german': "Deutsch",
	"sunday": "Воскресение",
	"monday": "Понедельник",
	"tuesday": "Вторник",
	"wednesday": "Среда",
	"thursday": "Четверг",
	"friday": "Пятница",
	"saturday": "Суббота",
	"sundayShort": "вс",
	"mondayShort": "пн",
	"tuesdayShort": "вт",
	"wednesdayShort": "ср",
	"thursdayShort": "чт",
	"fridayShort": "пт",
	"saturdayShort": "сб",
	"january": "Январь",
	"february": "Февраль",
	"march": "Март",
	"april": "Апрель",
	"may": "Май",
	"june": "Июнь",
	"july": "Июль",
	"august": "Август",
	"september": "Сентябрь",
	"october": "Октябрь",
	"november": "Ноябрь",
	"december": "Декабрь",
	"januaryGenitive": "Января",
	"februaryGenitive": "Февраля",
	"marchGenitive": "Марта",
	"aprilGenitive": "Апреля",
	"mayGenitive": "Мая",
	"juneGenitive": "Июня",
	"julyGenitive": "Июля",
	"augustGenitive": "Августа",
	"septemberGenitive": "Сентября",
	"octoberGenitive": "Октября",
	"novemberGenitive": "Ноября",
	"decemberGenitive": "Декабря",
	// --------------- end V2

	// --------------- V3
	"newtonsLaw": "Закон Ньютона",
	"topic": "Тема",
	"finished": "Завершенные",
	"stages": "Этапы",
	"confirmUploading": "Подтвердить загрузку",
	"fileDeletedSuccessfully": "Файл успешно удален",
	"fileDeletionError": "Возникла ошибка при попытке удалить файл",
	"isConfirmingStage": "Этап сейчас на подтверждении менеджера",
	"changeTemplateAnswer": "Изменить шаблонный ответ",
	"pages": "{n} страниц | {n} страница | {n} страницы | {n} страниц",
	"doYouWantToDeleteAuthorFromOrder": "Вы собираетесь удалить автора с заказа",
	"doYouWantToDeleteFile": "Вы собираетесь удалить файл",
	"youDeletedAuthorFromOrder": "Вы удалили автора с этого заказа",
	"noDataAvailable": "Данных не найдено",
	"secondsAgo": "0 Секунд назад | {n} Секунда назад | {n} Секунды назад | {n} Секунд назад",
	"minutesAgo": "0 Минут назад | {n} Минута назад | {n} Минуты назад | {n} Минут назад",
	"hoursAgo": "0 Часов назад | {n} Час назад | {n} Часа назад | {n} Часов назад",
	"daysAgo": "0 Дней назад | {n} День назад | {n} Дня назад | {n} Дней назад",
	"yearsAgo": "0 Лет назад | {n} Год назад | {n} Года назад | {n} Лет назад",
	"justNow": "Сейчас",
	// --------------- end V3

	"placeholderGlovalSearchOrderById": "Поиск заказа по номеру",
	"resultGlovalSearchOrderById": "Результат поиска заказа по номеру",
	"textNoResultGlovalSearchOrderById": "В системе не обнаружен заказ № ",

	"txtBtnManagerGetOrder": "Принять заказ",
	"titleModalAddNewManager": "Утверждаете менеджера?",
	"titleModalManagerGetOrder": "Принять заказ",
	"promtModalAddNewManager": "Вы хотите назначить нового менеджера?",
	"promtModalManagerGetOrder": "Вы принимаете заказ ",

	"txtBtnChatMarkAsRead": "Отметить прочитанным",
	"notifySuccessChatMarkAsRead": "Этот чат отмечен прочитанным!",

	"listTickets": {
		"idOrder": "№",
		"timeOrder": "Дата",
		"nameOrder": "Название заказа",
		"websiteOrder": "Сайт",
	},

	"exchange": {
		'id': '№',
		'name': 'Тема',
		'area': 'Предмет',
		'type': 'Тип',
		'page': 'Страниц',
		'stage': 'Этапов',
		'price': 'Цена',
		'price_junior_middle': "Цена для Junior/Middle",
		'price_senior': "Цена для Senior",
		'deadline': 'Дедлайн',
		'accept': 'Взять в работу',
		'decline': 'Отклонить',
		'confirmAction': 'Подтвердите действие',
		'confirmActionText': 'Вы собираетесь взять в работу этот заказ.',
		'confirmActionTextFalse': 'Вы собираетесь отклонить приглашение на этот заказ.',
		'confirmPopup': 'Подтвердить',
		'order': 'Заказ',
		'countStages': 'Кол-во этапов',
		'nameWork': 'Тема',
		'subject': 'Предмет',
		'typeWork': 'Тип работы',
		'levelQuality': 'Уровень качества',
		'countPages': 'Количество страниц',
		'attachFile': 'Прикрепленные файлы',
		'langWork': 'Язык выполнения',
		'comment': 'Комментарий',
		'getToWork': 'Приступить!',
		'filter': 'Фильтр',
		'searchToName': 'Поиск по названию',
		'level': 'Уровень',
		'off': 'От',
		'to': 'До',
		'reset': 'Сбросить',
		'inviteDecline': 'Приглашение отклонено',
		'inviteDeclineText': 'Вы успешно отклонили приглашение. Вы все еще сможете отправить заявку на выполнение этого заказа, если передумаете.',
		'inviteAccept': 'Приглашение принято',
		'inviteAcceptText': 'Спасибо, можете приступать к работе.',
		'requestSend': 'Заявка отправлена',
		'requestSendText': 'Спасибо, мы получили вашу зявку. Менеджер скоро ее подтвердит. Пожалуйста, подождите',
		'success': 'Успешно',
		'successText': 'Успешно выполнено',
		'deleteText': 'Успешно удалено',
		'acceptText': 'Успешно добавлено',
	},
	"stats": {
		"junior": 'Economy',
		"middle": 'Business',
		"senior": 'Academic',
		"income": 'Доход',
		"total": 'Net',
		"totalIncome": 'Доход',
		"privateIncome": 'Личный доход',
		"sitesCount": 'Сайтов',
		"paidOrdersCount": 'Оплаченных',
		"waitingOrdersCount": 'Повисшие',
		"graphIncome": 'Личный доход',
		"graphOrders": 'Заказы',
		"graphIncomeGlobal": 'Доход',
		"graphOrdersPaid": '"Повисшие" заказы',
		"completeOrder": 'Выполненные',
		"successOrder": 'Успешность',
		"today": 'Сегодня',
		"yesterday": 'Вчера',
		"currentWeek": 'Текущая неделя',
		"prevWeek": 'Прошлая неделя',
		"current_month": 'Текущий месяц',
		"last_month": 'Прошлый месяц',
		"last_three_month": '3 месяца',
		"last_six_month": 'Пол года',
		"last_year": 'Год',
		"all_time": 'За все время',
		"active": "Активных заказов",
		"clientsCount": 'Клиентов',
		"authorsCount": 'Авторов',
		"managersCount": 'Менеджеров',
		"incomeTotal": 'Gross',
		"incomeClean": 'Net',
		"ordersCount": 'Всего заказов',
		"graphUsers": 'Новые пользователи',
		"graphQualityLevels": 'Заказы по уровням качества',
		"graphSubjects": 'Заказы по предметам',
		"graphAdminIncome": 'Соотношение прибыли',
		"newPaidTickets": 'Заказы',
		"completedTickets": 'Статусы завершенных заказов',
		"conversion": 'Конверсия',
		"date": 'Дата',
		"manager": 'Менеджер',
		"clients": 'Клиенты',
		"authors": 'Авторы',
		"mangers": 'Менеджеров',
		"graph_new": 'Новых заказов',
		"paid": 'Оплаченных заказов',
		"completed": 'Выполнено',
		"failed": 'Провалено',
	},
};
